<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col>
          <v-text-field
            label="Third ID ECommerce"
            @input="updateThirdIdFiltered()"
            prepend-icon="mdi-magnify"
            v-model="sub_id"
            :prefix="`50- ${this.sub_id == null ? '' : this.sub_id} - `"
            solo
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-simple-table class="elevation-10">
        <template v-slot:default>
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Third ID ECommerce</th>
              <th scope="col">Name</th>
              <th scope="col">Type Code</th>
              <th scope="col">OverwriteDate</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="ecommerce in ecommerces"
              v-if="isECommerceFiltered(ecommerce)"
            >
              <td>{{ ecommerce.id }}</td>
              <td>{{ ecommerce.thirdIdEcommerce }}</td>
              <td>{{ ecommerce.name }}</td>
              <td>{{ ecommerce.typeCode }}</td>
              <td>{{ ecommerce.overwriteDate }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import { parameters } from "../../../parameters";
import { httpClient } from "../../../requesters/httpClient";

export default {
  name: "ECommerces",
  data() {
    return {
      ecommerces: [],
      id: "50",
      sub_id: null,
      third_id_filtered: "50--",
    };
  },
  async mounted() {
    await httpClient
      .get(`${parameters.posdataRefUrl}/e-commerce-overwrittens`)
      .then((response) => {
        this.ecommerces = response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  methods: {
    updateThirdIdFiltered: function () {
      this.sub_id = this.sub_id == null ? "" : this.sub_id;
      this.third_id_filtered = this.id + "-" + this.sub_id + "-" + this.sub_id;
    },

    isECommerceFiltered: function (ecommerce) {
      return (
        this.third_id_filtered === "50--" ||
        this.third_id_filtered === ecommerce.thirdIdEcommerce
      );
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/overwritten/eCommerces/ECommerces.vue